import { render, staticRenderFns } from "./class.vue?vue&type=template&id=0a8be66d&scoped=true&"
import script from "./class.vue?vue&type=script&lang=js&"
export * from "./class.vue?vue&type=script&lang=js&"
import style0 from "./class.vue?vue&type=style&index=0&id=0a8be66d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8be66d",
  null
  
)

export default component.exports